import gql from "graphql-tag";

export const FRAGMENT_OWNER = gql`
  fragment owner on Account {
    id
    name
    email
    sub
    groupId
  }
`;

export const FRAGMENT_STORAGE = gql`
  fragment storage on Storage {
    id
    fileUuid
    filename
    account {
      ...owner
    }
    container
  }

  ${FRAGMENT_OWNER}
`;

export const FRAGMENT_SOURCE = gql`
  fragment source on LegacyFile {
    id
    fileUuid
    sourceId
    folderId
    tags
    input
    state
    type
    storage {
      ...storage
    }
  }

  ${FRAGMENT_STORAGE}
`;

export const FRAGMENT_FILE = gql`
  fragment file on LegacyFile {
    ...source
    source {
      ...source
    }
  }

  ${FRAGMENT_SOURCE}
`;

export const FRAGMENT_EXPORT = gql`
  fragment Export on Export {
    id
    filename
    state
    metadata
    link: fileLink(expiry: 15) {
      url
      expiryDate
    }
  }
`;

export const FRAGMENT_ACCOUNT = gql`
  fragment account on Account {
    id
    name
    email
    sub
    group_id
  }
`;

export const FRAGMENT_PAGINATION_META = gql`
  fragment meta on PaginationMeta {
    totalItems
    itemCount
    itemsPerPage
    totalPages
    currentPage
  }
`;

export const FRAGMENT_RECORDING = gql`
  fragment recording on Recording {
    id: seqId
    uuid: id
    state
    tags
    name: filename
    owner {
      ...account
    }
  }

  ${FRAGMENT_ACCOUNT}
`;

export const FRAGMENT_FOLDER = gql`
  fragment folder on Folder {
    id
    parent_id
    label
    owner {
      ...account
    }
  }

  ${FRAGMENT_ACCOUNT}
`;
